import React from 'react';

import ReviewDetail from 'pages/Location/LocationDetail/ReviewDetail';

import { LOCATIONS } from 'constants/index';

const breadcrumbList = [
  {
    name: 'Quản lý đánh giá',
    isActive: false,
    link: LOCATIONS.MANAGER_REVIEWS,
  },
  {
    name: 'Chi tiết đánh giá',
    isActive: true,
    link: '',
  },
];

function ManagerReviewDetail() {
  return (
    <ReviewDetail
      breadcrumbList={breadcrumbList}
      isManagerReview
    />
  );
}

export default ManagerReviewDetail;
